import { Route, Routes } from "react-router-dom";
import RestaurantHome from "./components/restaurant/restaurant-home/restaurant-home.component";
import CustomerHome from "./components/customer/customer-home/customer-home.component";
import AHOne from "./components/apphome/ah1/ah1.component";
import RestaurantNavigation from "./components/restaurant/restaurant-navigation/restaurant-navigation.component";
import RestaurantOrder from "./components/restaurant/restaurant-order/restaurant-order.component";
import Tableside from "./components/restaurant/restaurant-order/tableside/tableside.component";
import RestaurantMenu from "./components/restaurant/restaurant-menu/restaurant-menu.component";
import RestaurantAccounts from "./components/restaurant/restaurant-accounts/restaurant-accounts.component";
import RestaurantCustomerCenter from "./components/restaurant/restaurant-customercenter/restaurant-customercenter.component";
import CurrentOrders from "./components/restaurant/restaurant-order/currentOrders/currentOrders.component";
import RestaurantCurrent from "./components/restaurant/restaurant-current/restaurant-current.component";
import RestaurantKitchen from "./components/restaurant/restaurant-kitchen/restaurant-kitchen.component";
import RestaurantInventory from "./components/restaurant/restaurant-inventory/restaurant-inventory.component";
import RestaurantOffers from "./components/restaurant/restaurant-offers/restaurant-offers.component";
import RestaurantLoyalty from "./components/restaurant/restaurant-loyalty/restaurant-loyalty.component";
import CustomerNavigation from "./components/customer/customer-navigation/customer-navigation.component";
import RestaurantSettings from "./components/restaurant/restaurant-settings/restaurant-settings.component";
import HostHome from "./components/affiliate/host/hostHome/hostHome.component";
import KitchenHome from "./components/affiliate/kitchen/kitchenHome/kitchenHome.component";

function App() {
  return (
    <Routes>
      <Route path="/">
        <Route index element={<AHOne />} />
      </Route>
      <Route path="home/" element={<RestaurantNavigation />}>
        <Route index element={<RestaurantHome />} />
        <Route path="menu" element={<RestaurantMenu />} />
        <Route path="accounts" element={<RestaurantAccounts />} />
        <Route path="settings" element={<RestaurantSettings />} />
        <Route path="customer_center">
          <Route index element={<RestaurantCustomerCenter />} />
          <Route path="offers" element={<RestaurantOffers />} />
          <Route path="loyalty" element={<RestaurantLoyalty />} />
        </Route>
        <Route path="current" element={<RestaurantCurrent />} />
        <Route path="inventory" element={<RestaurantInventory />} />
        <Route path="kitchen" element={<RestaurantKitchen />} />
        <Route path="order" element={<RestaurantOrder />}>
          <Route index element={<Tableside />} />
          <Route path="current" element={<CurrentOrders />} />
        </Route>
      </Route>
      <Route path="user/" element={<CustomerNavigation />}>
        <Route
          path=":id/tableside"
          element={<CustomerHome orderType={"tableside"} />}
        />
        <Route
          path=":id/takeaway"
          element={<CustomerHome orderType={"takeaway"} />}
        />
        <Route path=":id" element={<CustomerHome />} />
      </Route>
      <Route path="affiliate" element={<HostHome />}>
        <Route path="host" element={<RestaurantOrder />}>
          <Route index element={<Tableside />} />
          <Route path="current" element={<CurrentOrders />} />
        </Route>
      </Route>
      <Route path="affiliate" element={<KitchenHome />}>
        <Route path="kitchen" element={<RestaurantKitchen />} />
      </Route>
    </Routes>
  );
}

export default App;
